import { render, staticRenderFns } from "./newInfo.vue?vue&type=template&id=08efc2a9&scoped=true&"
import script from "./newInfo.vue?vue&type=script&lang=js&"
export * from "./newInfo.vue?vue&type=script&lang=js&"
import style0 from "./newInfo.vue?vue&type=style&index=0&id=08efc2a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08efc2a9",
  null
  
)

export default component.exports